/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_ClearInputs */

const en_btn_clear = /** @type {(inputs: Btn_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear`)
};

const ko_btn_clear = /** @type {(inputs: Btn_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초기화`)
};

const ja_btn_clear = /** @type {(inputs: Btn_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリア`)
};

/**
* | output |
* | --- |
* | "Clear" |
*
* @param {Btn_ClearInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const btn_clear = /** @type {((inputs?: Btn_ClearInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_ClearInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_clear(inputs)
	if (locale === "ko") return ko_btn_clear(inputs)
	return ja_btn_clear(inputs)
});